import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-seo',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './seo.html',
  styleUrl: './seo.css'
})
export class SeoComponent {
  features = [
    {
      icon: 'search',
      title: 'Technical SEO',
      description: 'Optimize your website\'s technical foundation for better search engine crawling and indexing. We handle site speed, mobile optimization, structured data, and XML sitemaps.'
    },
    {
      icon: 'article',
      title: 'Content Marketing',
      description: 'Create high-quality, SEO-optimized content that engages your audience and ranks well. From blog posts to landing pages, we craft content that converts.'
    },
    {
      icon: 'link',
      title: 'Link Building',
      description: 'Build authoritative backlinks that boost your domain authority and search rankings. We use white-hat strategies to earn quality links from relevant sources.'
    },
    {
      icon: 'location_on',
      title: 'Local SEO',
      description: 'Dominate local search results with optimized Google Business Profile, local citations, and location-based content strategies that drive foot traffic.'
    },
    {
      icon: 'analytics',
      title: 'Keyword Research',
      description: 'Identify high-value keywords with commercial intent. We analyze search volume, competition, and user intent to target the right opportunities.'
    },
    {
      icon: 'fact_check',
      title: 'SEO Audits',
      description: 'Comprehensive technical and content audits to identify issues and opportunities. Get actionable recommendations to improve your search visibility.'
    }
  ];

  process = [
    {
      step: '01',
      title: 'SEO Audit & Research',
      description: 'We start with a comprehensive analysis of your current SEO performance, competitor landscape, and keyword opportunities to create a data-driven strategy.'
    },
    {
      step: '02',
      title: 'On-Page Optimization',
      description: 'Optimize your website\'s content, meta tags, headers, and internal linking structure. We ensure every page is properly optimized for target keywords.'
    },
    {
      step: '03',
      title: 'Content Creation & Link Building',
      description: 'Create valuable content that attracts links naturally and execute targeted outreach campaigns to build high-quality backlinks from authoritative sites.'
    },
    {
      step: '04',
      title: 'Monitor & Refine',
      description: 'Track rankings, organic traffic, and conversions. We continuously refine the strategy based on performance data and algorithm updates.'
    }
  ];

  caseStudy = {
    client: 'TechGear Pro',
    industry: 'E-commerce Electronics',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
    challenge: 'TechGear Pro was struggling to compete with major electronics retailers in organic search. Their product pages weren\'t ranking, and they had minimal organic traffic despite a large product catalog.',
    solution: 'We implemented a comprehensive SEO strategy including technical optimization, product page optimization, content marketing with buying guides, and a strategic link building campaign targeting tech review sites.',
    results: [
      '385% increase in organic traffic',
      '250% growth in organic revenue',
      '1,200+ keywords ranking on page 1',
      '45% improvement in conversion rate'
    ]
  };

  testimonial = {
    quote: 'HoneyKode transformed our online visibility. Within 6 months, we went from page 3 to dominating page 1 for our most important keywords. The organic traffic growth has been incredible, and more importantly, the quality of leads has improved dramatically.',
    author: 'Michael Torres',
    role: 'Marketing Director',
    company: 'TechGear Pro',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop'
  };
}
